/**
 * pass in strings to join together as class names with spaces between
 * a single string parameter may have multiple classes in it (ie "class1 class2 class3")
 * and it will be joined with the other passed in parameters.
 * duplicate classes will become just one
 * they will be sorted afterwards, just for an awesomeness factor of AWESOME!
 */
export default function joinClassNames() {
	// can pass in any # of parameters
	return Array.from(Array.prototype.slice.call(arguments)
	// split each class chunk in to parts
		.map(classString => classString ? classString.split(' ') : [])
		// reduce to a set for uniqueness
		.reduce((set, classArray) => {
			classArray.filter(s => s).forEach(singleClass => set.add(singleClass));
			return set;
		}, new Set()))
	// sorting is awesome!
		.sort()
		// converted to an array, so join with spaces
		.join(' ') || undefined;
}
